import { render, staticRenderFns } from "./TutorViewUserInfoCard.vue?vue&type=template&id=1477d995&"
import script from "./TutorViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./TutorViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports